import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const UserProfileMenuButtonIntegration = () =>
  import(/* webpackChunkName: "4-feat-user-profile-menu-button" */ './UserProfileMenuButtonIntegration');

export default lazyLoadOnRender({ loader: UserProfileMenuButtonIntegration });
